// this file is generated by update_shopify_store_data.py at 2026-11-03 20:15:34.397154
var courses = [
    {
        "course_id": "88298BDB-0186-F111-99B9-005056A77B46",
        "course_version": 1,
        "name": "Lifebeat Solutions - Error-Free Nursing Practice",
        "course_type": 32,
        "author_information": "",
        "description": "This Lifebeat Solution program includes eleven important courses that focus on refining nursing practices to minimize errors and enhance patient safety. Nurses will learn essential techniques to improve clinical reasoning, communication, and error prevention strategies.",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "30D5495F-0186-F111-99B9-005056A77B46",
                "course_category_name": "Lifebeat Solutions - Error-Free Nursing Practice - Curriculum",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "017C478E-CE70-F111-99B5-005056A7013F",
                "course_version": 2,
                "name": "Documentation Errors and Patient Data Communication",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module trains nurses to create accurate, timely, and legally defensible documentation. Learners understand how poor charting leads to patient harm, communication failure, and liability \u2014 and develop strategies to ensure clinical findings, communication, and decisions are clearly recorded to support safe care and continuity.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses describe the role of documentation in supporting safe, continuous patient care.</li>\r\n    <li>Nurses explain the nursing documentation process and its legal significance.</li>\r\n    <li>Nurses identify the clinical and legal consequences of documentation errors.</li>\r\n    <li>Nurses apply best practices for accurate, timely, and legally defensible documentation.</li>\r\n    <li>Nurses communicate patient data effectively to support continuity and safety of care.</li>\r\n</ul>",
                "course_outline_html": "<h3>Documentation Errors and Patient Data Communication</h3>\r\n<p>This course strengthens accurate documentation practices and effective communication of patient data across care teams.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Introduction to Documentation in Nursing</li>\r\n    <li>Understanding the Documentation Process</li>\r\n    <li>Impact of Documentation Errors</li>\r\n    <li>Best Practices for Documentation</li>\r\n    <li>Effective Communication of Patient Data</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Complete documentation exercises</li>\r\n    <li>Pass assessment quiz</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D92997B-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B667E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7BE7488F-CEC9-E511-82AF-005056B150D3",
                        "course_category_name": "Documentation and Reporting",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                        "course_category_name": "All Settings",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4ADC5A2E-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Clinical Documentation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CE9E1209-CE8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Diagnostic & Patient Monitoring Equipment",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C17A92DE-0BEA-E511-B707-005056B16096",
                        "course_category_name": "Informatics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E406CCCD-64D6-E511-9382-005056B13023",
                        "course_category_name": "EMRs",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "E2558570-D170-F111-99B5-005056A7013F",
                "course_version": 2,
                "name": "Interventions for Enhanced Patient Safety",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module trains nurses to apply human factors principles, risk stratification, and behavioral safety strategies in daily practice. Learners build safer routines, recognize system vulnerabilities, and reduce error likelihood \u2014 strengthening reliability and resilience in patient care environments.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses apply core patient safety principles to daily nursing practice.</li>\r\n    <li>Nurses implement strategies to protect vulnerable patient populations from harm.</li>\r\n    <li>Nurses apply de-escalation and protective strategies for managing aggressive patient behavior.</li>\r\n    <li>Nurses apply human factors and systems thinking principles to reduce error likelihood.</li>\r\n    <li>Nurses utilize risk assessment and quality improvement principles to strengthen patient safety.</li>\r\n</ul>",
                "course_outline_html": "<h3>Interventions for Enhanced Patient Safety</h3>\r\n<p>This course explores system-based strategies and interventions that enhance patient safety and reduce risk.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Adherence to Patient Safety Principles</li>\r\n    <li>Protecting Vulnerable Patients</li>\r\n    <li>Aggressive Behavior: Protecting the Patient &amp; Nurse</li>\r\n    <li>Human Factors &amp; Systems Thinking</li>\r\n    <li>Risk Assessment &amp; Quality Improvement</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Participate in safety improvement scenarios</li>\r\n    <li>Pass assessment quiz</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DBA6766-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Health Promotion and Wellness",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D92997B-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B667E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FEC6E955-D5C9-E511-82AF-005056B150D3",
                        "course_category_name": "Risk Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                        "course_category_name": "Patient Monitoring",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                        "course_category_name": "All Settings",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3B66D963-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Quality Assurance and Performance Improvement",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "D27DAA72-D470-F111-99B5-005056A7013F",
                "course_version": 2,
                "name": "Mastering Clinical Reasoning",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module bridges the gap between data collection and decisive action. Nurses learn to interpret ambiguous findings, manage uncertainty, and make safe decisions in complex situations \u2014 strengthening clinical reasoning to prevent delayed intervention and reduce Failure to Rescue across all care settings.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses differentiate clinical reasoning from clinical judgment in nursing practice.</li>\r\n    <li>Nurses apply systematic approaches to gathering and interpreting patient data.</li>\r\n    <li>Nurses apply critical thinking principles to support safe clinical decision-making.</li>\r\n    <li>Nurses manage uncertainty and complexity when clinical findings are ambiguous.</li>\r\n    <li>Nurses identify the impact of cognitive bias and ethical considerations on clinical reasoning.</li>\r\n</ul>",
                "course_outline_html": "<h3>Mastering Clinical Reasoning &amp; Clinical Judgment</h3>\r\n<p>This course enhances clinical reasoning and decision-making to improve patient outcomes in complex situations.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Understanding Clinical Reasoning &amp; Clinical Judgment</li>\r\n    <li>Gathering &amp; Interpreting Patient Data</li>\r\n    <li>Critical Thinking &amp; Decision-Making</li>\r\n    <li>Dealing with Uncertainty &amp; Complexity</li>\r\n    <li>Impact of Bias &amp; Ethical Considerations</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Complete clinical case simulations</li>\r\n    <li>Pass final assessment</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                        "course_category_name": "All Settings",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1E8E3774-CEC9-E511-82AF-005056B150D3",
                        "course_category_name": "Diagnostic Tests & Examinations",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Professional Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B667E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D92997B-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                        "course_category_name": "Patient Monitoring",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "F2374F68-D570-F111-99B5-005056A7013F",
                "course_version": 2,
                "name": "Medication Error Management",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module strengthens nurses\u2019 ability to prevent, recognize, and respond to medication errors. Learners identify high-risk failure points, apply double-check systems, educate patients, and use root cause analysis to reduce harm \u2014 protecting patients through safer medication practices and interruption of error chains.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses describe the most common causes and types of medication errors in clinical practice.</li>\r\n    <li>Nurses apply evidence-based strategies to prevent medication errors before they reach the patient.</li>\r\n    <li>Nurses implement safe medication administration practices to reduce error risk.</li>\r\n    <li>Nurses identify high-risk medications and patient populations requiring heightened vigilance.</li>\r\n    <li>Nurses apply reporting and root cause analysis principles to learn from medication errors.</li>\r\n</ul>",
                "course_outline_html": "<h3>Medication Error Management</h3>\r\n<p>This course focuses on identifying, preventing, and responding to medication errors to improve patient safety outcomes.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Understanding Medication Errors</li>\r\n    <li>Strategies for Preventing Medical Errors</li>\r\n    <li>Safe Medication Administration</li>\r\n    <li>High-Risk Medications &amp; Patient Populations</li>\r\n    <li>Reporting &amp; Learning from Medication Errors</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Participate in medication safety scenarios</li>\r\n    <li>Pass assessment quiz</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8D3F3C75-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                        "course_category_name": "Patient Monitoring",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "87DDC116-CC8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Medication Error Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B667E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D92997B-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF67E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pharmacology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C02850F-CC8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Medication Administration",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                        "course_category_name": "All Settings",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "36D8ADCC-D370-F111-99B5-005056A7013F",
                "course_version": 2,
                "name": "Mandated Reporting in Nursing",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module prepares nurses to recognize abuse, neglect, and unsafe conditions requiring mandatory reporting. Learners understand legal obligations, documentation practices, and escalation pathways \u2014 protecting vulnerable patients through timely reporting and reinforcing the nurse\u2019s role in safeguarding human dignity.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses describe the nurse's legal obligations related to mandated reporting.</li>\r\n    <li>Nurses recognize signs of abuse and neglect requiring mandatory reporting.</li>\r\n    <li>Nurses apply the appropriate reporting process when abuse or neglect is suspected.</li>\r\n    <li>Nurses identify the legal and ethical considerations associated with mandated reporting.</li>\r\n    <li>Nurses support patients and families throughout the mandated reporting process.</li>\r\n</ul>",
                "course_outline_html": "<h3>Mandated Reporting in Nursing</h3>\r\n<p>This course equips nurses with the knowledge and legal responsibility to identify and report abuse and neglect.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Introduction to Mandated Reporting</li>\r\n    <li>Recognizing Signs of Abuse and Neglect</li>\r\n    <li>The Reporting Process</li>\r\n    <li>Legal and Ethical Considerations</li>\r\n    <li>Supporting Patients and Families</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Complete reporting simulation</li>\r\n    <li>Pass assessment quiz</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "411A8674-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Violence & Abuse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B667E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D92997B-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "311E9BEF-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Community Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DA6A4541-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Mandatory Reporting",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                        "course_category_name": "All Settings",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "84586E86-BF29-11DE-88D6-0015171C1B93",
                        "course_category_name": "Legal & Corporate Compliance",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "18A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Geriatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                        "course_category_name": "Patient Monitoring",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "46831B99-D070-F111-99B5-005056A7013F",
                "course_version": 2,
                "name": "Interpretation of Authorized Orders",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module clarifies nurses\u2019 legal and clinical responsibilities when receiving, verifying, and implementing provider orders. Learners address ambiguous, incomplete, or unsafe orders through proper clarification and documentation \u2014 preventing medication and treatment errors that contribute to patient harm.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses interpret provider orders accurately within the nurse's scope of practice.</li>\r\n    <li>Nurses apply communication strategies to clarify ambiguous or incomplete orders.</li>\r\n    <li>Nurses identify the legal and ethical considerations involved in order interpretation.</li>\r\n    <li>Nurses verify medication orders to prevent administration errors.</li>\r\n    <li>Nurses interpret orders for treatments and procedures to ensure safe implementation.</li>\r\n</ul>",
                "course_outline_html": "<h3>Interpretation of Authorized Orders</h3>\r\n<p>This course develops competency in interpreting, verifying, and clarifying clinical orders to ensure patient safety.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Provider Order Interpretation</li>\r\n    <li>Communicating and Clarifying Orders</li>\r\n    <li>Legal and Ethical Considerations in Order Interpretation</li>\r\n    <li>Medication Order Verification</li>\r\n    <li>Interpreting Orders for Treatments and Procedures</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Complete order verification exercises</li>\r\n    <li>Pass assessment quiz</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4ADC5A2E-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Clinical Documentation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B667E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DBA6766-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Health Promotion and Wellness",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D92997B-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C02850F-CC8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Medication Administration",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                        "course_category_name": "All Settings",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CE9E1209-CE8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Diagnostic & Patient Monitoring Equipment",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "5B21433F-5F71-F111-99AF-005056A7F5E9",
                "course_version": 2,
                "name": "Nursing Surveillance, Attentiveness and Vigilance",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module defines surveillance as the backbone of patient safety. Nurses learn how to prioritize subtle cues, recognize early deterioration, and intervene before crises occur \u2014 building sustainable vigilance without burnout and reducing Failure to Rescue through intentional, moment-to-moment clinical awareness.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses define surveillance, attentiveness, and vigilance as core components of patient safety.</li>\r\n    <li>Nurses apply effective nursing surveillance techniques to detect early signs of deterioration.</li>\r\n    <li>Nurses describe the role of attentiveness in sustaining safe nursing practice.</li>\r\n    <li>Nurses implement vigilance strategies that safeguard patient safety without contributing to burnout.</li>\r\n    <li>Nurses identify high-risk patients and situations requiring heightened surveillance.</li>\r\n</ul>",
                "course_outline_html": "<h3>Nursing Surveillance, Attentiveness, &amp; Vigilance</h3>\r\n<p>This course builds clinical vigilance skills to improve early detection of patient deterioration.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Introduction to Surveillance, Attentiveness, &amp; Vigilance</li>\r\n    <li>Effective Nursing Surveillance</li>\r\n    <li>Role of Attentiveness in Nursing Practice</li>\r\n    <li>Vigilance: Safeguarding Patient Safety</li>\r\n    <li>Identifying High-Risk Patients &amp; Situations</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Participate in simulation exercises</li>\r\n    <li>Pass scenario-based assessment</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF67E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                        "course_category_name": "Patient Monitoring",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B667E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8D3F3C75-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D92997B-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "ACF93CFC-6971-F111-99AF-005056A7F5E9",
                "course_version": 2,
                "name": "Sepsis and Healthcare-Associated Infections (HAIs)",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module equips nurses to detect early sepsis and interrupt infection transmission. Learners recognize subtle signs of deterioration, initiate timely protocols, and strengthen infection-prevention practices \u2014 reducing Failure to Rescue and improving outcomes through early intervention and system-level safety action.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses describe the pathophysiology and early clinical presentation of sepsis.</li>\r\n    <li>Nurses apply evidence-based protocols for the clinical management of sepsis.</li>\r\n    <li>Nurses identify common healthcare-associated infections and their risk factors.</li>\r\n    <li>Nurses implement prevention and control strategies to reduce sepsis and HAI incidence.</li>\r\n    <li>Nurses describe advanced clinical considerations in the management of sepsis and HAIs.</li>\r\n</ul>",
                "course_outline_html": "<h3>Sepsis and Healthcare-Associated Infections (HAIs)</h3>\r\n<p>This course develops competencies in identifying, managing, and preventing sepsis and healthcare-associated infections.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Introduction to Sepsis</li>\r\n    <li>Clinical Management of Sepsis</li>\r\n    <li>Healthcare-Associated Infections (HAIs): An Overview</li>\r\n    <li>Prevention and Control of Sepsis and HAIs</li>\r\n    <li>Advanced Topics in Sepsis and HAIs</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Complete sepsis simulation scenario</li>\r\n    <li>Pass assessment quiz</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6F560093-37E7-11DD-B494-001517135513",
                        "course_category_name": "Infectious Diseases",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D92997B-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FB1CBC9E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Infection",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B667E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                        "course_category_name": "Patient Monitoring",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CD33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Infection Control",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "2AB00A86-DD70-F111-99AF-005056A7F5E9",
                "course_version": 2,
                "name": "Nursing Role in Harm Prevention",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module empowers nurses to prevent common hospital-acquired harms, including falls, pressure injuries, and infections. Learners apply evidence-based prevention strategies across care settings and transitions \u2014 strengthening frontline leadership in harm reduction and advancing the mission of Zero Patient Harm.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses recognize signs of patient deterioration and apply rapid response activation criteria.</li>\r\n    <li>Nurses implement evidence-based strategies to prevent falls and venous thromboembolism (VTE).</li>\r\n    <li>Nurses apply evidence-based strategies to prevent pressure ulcers.</li>\r\n    <li>Nurses implement infection prevention strategies to reduce healthcare-associated harm.</li>\r\n    <li>Nurses apply discharge planning and medication reconciliation practices to prevent post-discharge harm.</li>\r\n</ul>",
                "course_outline_html": "<h3>Nursing Role in Harm Prevention</h3>\r\n<p>This course focuses on proactive nursing interventions that reduce patient harm and improve safety outcomes.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Recognizing Patient Deterioration &amp; Rapid Response Teams</li>\r\n    <li>Preventing Patient Falls &amp; Venous Thromboembolism (VTE)</li>\r\n    <li>Preventing Pressure Ulcers</li>\r\n    <li>Preventing Healthcare-Associated Infections</li>\r\n    <li>Discharge Planning &amp; Medication Reconciliation</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Participate in risk-prevention scenarios</li>\r\n    <li>Pass assessment quiz</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                        "course_category_name": "Patient Monitoring",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FEC6E955-D5C9-E511-82AF-005056B150D3",
                        "course_category_name": "Risk Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FB1CBC9E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Infection",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CD33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Infection Control",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D92997B-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B667E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "0A5DE5F3-6071-F111-99AF-005056A7F5E9",
                "course_version": 2,
                "name": "Preoperative Surgical Care",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module prepares nurses to ensure pre-operative safety through risk stratification, consent verification, site confirmation, and checklist compliance. Learners prevent surgical delays, errors, and wrong-site events by strengthening pre-procedure vigilance and communication \u2014 protecting patients before harm occurs.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses conduct a comprehensive preoperative patient evaluation.</li>\r\n    <li>Nurses apply principles of patient education and informed consent prior to surgical procedures.</li>\r\n    <li>Nurses implement preoperative checklists and safety protocols to prevent surgical errors.</li>\r\n    <li>Nurses apply preoperative risk assessment and stratification to guide patient preparation.</li>\r\n    <li>Nurses manage fasting status and medication considerations prior to surgery.</li>\r\n</ul>",
                "course_outline_html": "<h3>Preoperative Surgical Care</h3>\r\n<p>This course prepares nurses to deliver safe and effective preoperative care for surgical patients.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Patient Evaluation</li>\r\n    <li>Patient Education and Informed Consent</li>\r\n    <li>Checklists and Safety Protocols</li>\r\n    <li>Preoperative Risk Assessment and Stratification</li>\r\n    <li>Fasting and Medication Management</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Complete surgical safety checklist activity</li>\r\n    <li>Pass assessment quiz</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3D3623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Perioperative Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B667E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C118C362-7EE5-E511-BF27-005056B17F80",
                        "course_category_name": "Patient Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF67E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                        "course_category_name": "Patient Monitoring",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8D3F3C75-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Medicine",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7334B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgical Procedures",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D92997B-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "CF741EB4-6171-F111-99AF-005056A7F5E9",
                "course_version": 2,
                "name": "Professional Responsibility and Patient Advocacy",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module builds nurses\u2019 capacity for ethical decision-making and patient advocacy. Learners develop moral courage, boundary awareness, and escalation strategies to speak up for safety \u2014 strengthening professional accountability and reducing harm through decisive, patient-centered action.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses describe the scope of professional responsibility in nursing practice.</li>\r\n    <li>Nurses apply patient advocacy and empowerment principles in clinical decision-making.</li>\r\n    <li>Nurses apply ethical decision-making frameworks to complex clinical situations.</li>\r\n    <li>Nurses identify sources of moral distress and strategies to address them professionally.</li>\r\n    <li>Nurses maintain appropriate professional boundaries in nursing practice.</li>\r\n</ul>",
                "course_outline_html": "<h3> Professional Responsibility &amp; Patient Advocacy</h3>\r\n<p>This course builds ethical decision-making and advocacy skills essential to professional nursing practice.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Professional Responsibility in Nursing Practice</li>\r\n    <li>Patient Advocacy and Empowerment</li>\r\n    <li>Ethical Decision-Making</li>\r\n    <li>Ethics &amp; Moral Distress</li>\r\n    <li>Professional Boundaries in Nursing</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Participate in ethics scenarios</li>\r\n    <li>Pass reflection and assessment</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "4D92997B-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B667E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0E34B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Patient Rights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Professional Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "971E14AF-67DA-E511-9165-005056B141CC",
                        "course_category_name": "Ethical Practice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "64AC0E63-34D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Patient Advocacy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                        "course_category_name": "Patient Monitoring",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                        "course_category_name": "All Settings",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            }
        ]
    }
];